module.exports = __webpack_public_path__ + "img/check-erro.8d56ebfe.svg";